import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import api from '@/api/client'
import { CERTIFICATIONS, type Certification } from '@/data/certifications'
import { mergeCatalog, type CatalogLevel } from '@/data/certCatalog'

/**
 * Elenco dei brevetti: il catalogo di profile fuso sull'elenco statico. Se l'API non risponde
 * (o non ha ancora dati) si vede l'elenco statico, come prima: la pagina non aspetta e non si rompe.
 */
export function useCertifications(): Certification[] {
  const { data } = useQuery({
    queryKey: ['certification-catalog'],
    queryFn: () => api.get<{ levels: CatalogLevel[] }>('/v1/profile/certification-catalog').then((r) => r.data.levels),
    staleTime: 10 * 60 * 1000,
    retry: false,
  })
  return useMemo(() => mergeCatalog(CERTIFICATIONS, data), [data])
}
